import { useLocation } from 'react-router-dom';
import { IconButton, MenuIcon, Dialog, Box } from 'src/components';
import { HandbookMenu } from 'src/pages'; 
import { useAuth } from 'src/utils';

export default function MobileHeader({ handbookMenuTab, setHandbookMenuTab }) {
    const location = useLocation();
    const { user } = useAuth();
    const isHandbook = location.pathname.includes("handbook");

    const handleOpen = () => {
        setHandbookMenuTab('chapters');
    };

    const handleClose = () => {
        setHandbookMenuTab(null);
    };

    const open = Boolean(handbookMenuTab);

    return (
        <>
            {user && user.hasCompletedOnboarding && isHandbook && (
                <>
                    <IconButton 
                        disableRipple 
                        sx={{
                            paddingTop: 'var(--safe-area-top)',
                            zIndex: 1300, 
                            position: 'absolute', 
                            marginTop: '20px',
                            top: 10, 
                            right: 10, 
                        }}
                        onClick={handleOpen}
                    >
                        <MenuIcon size="large" sx={{ color: '#fff' }} />
                    </IconButton>

                    <Dialog
                        fullScreen
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                            sx: {
                                backgroundColor: 'background.default',
                            }
                        }}
                    >
                        <Box
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                p: 2,
                            }}
                        >
                            <HandbookMenu
                                handbookMenuTab={handbookMenuTab}
                                onClose={handleClose}
                            />
                        </Box>
                    </Dialog>
                </>
            )}
        </>
    );
}
